<ng-container *ngIf="urlData$ | async as urlData">
  <app-post-link-preview-view [data]="urlData"></app-post-link-preview-view>
</ng-container>
